<template>
  <v-dialog v-model="dialog" persistent width="1200">
    <v-card class="p-0">
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ !!form.grupo ? "edit" : "add" }}</v-icon>
          {{ !!form.grupo ? "Editar horario" : "Crear horario" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <!-- {{ form }}------ <br />
      {{ l_horarios }}
      {{ !!form.grupo }} -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="px-3">
          <v-container grid-list-md class="p-0" style="min-width: 100%">
            <v-layout wrap row>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Descripción"
                  v-model="form.descripcion"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="tipo_jornada"
                  item-value="id"
                  item-text="tipo"
                  v-model="form.jornada"
                  label="Ingrese la jornada laboral"
                  :rules="$validate(['required'])"
                  outline
                  clearable
                  required
                  :disabled="!!form.grupo"
                  :readonly="!!form.grupo"
                />
              </v-flex>
            </v-layout>
            <v-layout
              wrap
              row
              v-for="horario in form.jornada == 'C'
                ? l_horarios.filter(ele => ele.numero == 1)
                : l_horarios"
              :key="horario.id"
            >
              <v-flex xs12>
                <v-chip color="#ff5c0a" text-color="white">
                  {{
                    form.jornada == "C"
                      ? horario.desc1_continuo
                      : horario.desc1_discontinuo
                  }}
                </v-chip>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Hora Ingreso "
                  v-model="horario.hora_inicio"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Tolerancia en min."
                  v-model="horario.tolerancia_inicio"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Rango inicio (Para procesar)"
                  v-model="horario.rango_inicio_inicio"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Rango fin (Para procesar)"
                  v-model="horario.rango_fin_inicio"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-chip color="indigo" text-color="white">
                  {{
                    form.jornada == "C"
                      ? horario.desc2_continuo
                      : horario.desc2_discontinuo
                  }}
                </v-chip>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Hora Salida "
                  v-model="horario.hora_fin"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Tolerancia en min."
                  v-model="horario.tolerancia_fin"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Rango inicio en min. (Para procesar)"
                  v-model="horario.rango_inicio_fin"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Rango fin en min.(Para procesar)"
                  v-model="horario.rango_fin_fin"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  type="time"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-chip color="cyan" text-color="white">Jornadas</v-chip>
            <v-layout row wrap>
              <v-flex
                v-for="(jornada, index) in l_jornadas"
                :key="index"
                xs12
                sm6
                md4
              >
                <v-card
                  class="pa-2 text-xs-center"
                  :color="jornada.color"
                  style="border-radius: 15px;"
                >
                  <v-layout column wrap>
                    <v-flex xs12 style="font-weight: 800;"
                      >{{ jornada.descripcion }}
                    </v-flex>
                    <v-flex xs12 class="d-flex justify-center ">
                      <span
                        class="material-symbols-outlined"
                        style="font-size: 10rem; position: absolute;color: rgba(0, 0, 0,0.035);"
                      >
                        {{ jornada.icono }}
                      </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="text-field-reducido-border"
                        label="Hora inicio"
                        v-model="jornada.hora_inicio"
                        :rules="$validate(['required'])"
                        required
                        outline
                        clearable
                        type="time"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="text-field-reducido-border"
                        label="Hora fin"
                        v-model="jornada.hora_fin"
                        :rules="$validate(['required'])"
                        required
                        outline
                        clearable
                        type="time"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      tipo_jornada: [
        { id: "C", tipo: "CONTINUO" },
        { id: "D", tipo: "DISCONTINUO" }
      ],
      l_jornadas: [],
      l_horarios: [
        {
          numero: 1,
          desc1_continuo: "Mañana/ Ingreso",
          desc2_continuo: "Tarde/ Salida",
          desc1_discontinuo: "Mañana/ Ingreso",
          desc2_discontinuo: "Mañana/ Salida"
        },
        {
          numero: 2,
          desc1_continuo: "Tarde / Ingreso",
          desc2_continuo: "Tarde/ Salida",
          desc1_discontinuo: "Tarde / Ingreso",
          desc2_discontinuo: "Tarde/ Salida"
        }
      ],
      l_horarios_copia: []
    };
  },
  mounted() {
    // Le sacamos una copia para volver a generar la lista cuando se cierre el dialog
    this.l_horarios_copia = JSON.parse(JSON.stringify(this.l_horarios));
    this.$bus.$on("openDialogCrearActualizarHorario", async item => {
      this.form = { ...item, jornada: "C" };
      // Cargamos jornadas
      await this.cargarJornadas();
      // Para editar
      if (this.form.grupo) {
        this.cargarDatosEdicion();
      }
      this.dialog = true;
    });
  },
  methods: {
    // Metodo para cargar datos en la edicion
    cargarDatosEdicion() {
      // Cargamos descripcion
      this.form.descripcion = this.form.descripcion_horario;
      this.form.jornada = this.form.tipo_horario;
      // Cargamos horarios ( USAMOS EL FORMAT PARA QUITAR SEGUNDOS, EN LA BD SE LE SUMA AUTOMATICAMENTE 59 SEG ojo)
      for (let index = 0; index < this.form.horarios.length; index++) {
        const element = this.form.horarios[index];
        var horario = this.l_horarios[index];
        horario.id_horario = element.id_horario;
        horario.id_rango_inicio = element.id_horario_rango_1;
        horario.id_rango_fin = element.id_horario_rango_2;
        horario.hora_inicio = element.horario;
        horario.tolerancia_inicio = element.tolerancia_1;
        horario.rango_inicio_inicio = this.$moment(element.rango_ini,'HH:mm:ss').format('HH:mm');
        horario.rango_fin_inicio = this.$moment(element.rango_fin,'HH:mm:ss').format('HH:mm');
        horario.hora_fin = element.horario_2;
        horario.tolerancia_fin = element.tolerancia_2;
        horario.rango_inicio_fin = this.$moment(element.rango_ini_2,'HH:mm:ss').format('HH:mm') ;
        horario.rango_fin_fin = this.$moment(element.rango_fin_2,'HH:mm:ss').format('HH:mm')  ;
      }
      // Cargamos jornadas
      for (let index = 0; index < this.l_jornadas.length; index++) {
        const element = this.l_jornadas[index];
        // Buscamos las jornadas creadas
        const jornada_found = this.form.jornadas.find(
          ele => ele.id_jornada == element.id
        );
        element.id_horario_jornada = jornada_found.id;
        element.hora_inicio = jornada_found.hora_inicio;
        element.hora_fin = jornada_found.hora_fin;
      }
    },
    // Metodo para cargar las jornadas
    async cargarJornadas() {
      try {
        //cargar horarios:
        let respuesta = await this.$service.graphql({
          query: `
            query {
              jornadas{
                rows{
                  id
                  descripcion
                  sigla
                  color
                  icono
                }
              }
            }
				`
        });
        var l_tmp = respuesta.jornadas.rows;
        this.l_jornadas = l_tmp;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.l_horarios = JSON.parse(JSON.stringify(this.l_horarios_copia));
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogCrearHorario");
      this.dialog = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        // Validamos que se llenaron los horarios y jornadas
        var l_hora_oficial =
          this.form.jornada == "C"
            ? this.l_horarios.filter(ele => ele.numero == 1)
            : this.l_horarios;
        let l_hora_valida = l_hora_oficial.filter(
          hora =>
            !!hora.hora_inicio &&
            !!hora.tolerancia_inicio &&
            !!hora.rango_inicio_inicio &&
            !!hora.rango_fin_inicio &&
            !!hora.hora_fin &&
            !!hora.tolerancia_fin &&
            !!hora.rango_inicio_fin &&
            !!hora.rango_fin_fin
        );
        // Si todos los campos estan completos las longitudes de los array deberian ser los mismos
        if (l_hora_valida.length != l_hora_oficial.length) {
          this.$message.info("No termino de llenar los datos de los horarios");
          return;
        }
        // Validamos que se llenaron las jornadas
        let l_jornada_valida = this.l_jornadas.filter(
          jorna => !!jorna.hora_inicio && !!jorna.hora_fin
        );
        if (l_jornada_valida.length != this.l_jornadas.length) {
          this.$message.info("No termino de llenar los datos de las jornadas");
          return;
        }

        this.loading = true;
        let user = this.$storage.get("user");
        try {
          // Armamos horarios
          var lista_horarios = l_hora_oficial.map(ele => {
            let horario = JSON.parse(JSON.stringify(ele));
            delete horario.numero;
            delete horario.desc1_continuo;
            delete horario.desc2_continuo;
            delete horario.desc1_discontinuo;
            delete horario.desc2_discontinuo;
            return horario;
          });
          // Armamos jornadas
          var lista_jornadas = this.l_jornadas.map(ele => {
            let jornada = JSON.parse(JSON.stringify(ele));
            delete jornada.descripcion;
            delete jornada.sigla;
            delete jornada.color;
            delete jornada.icono;
            jornada.id_jornada = jornada.id;
            delete jornada.id;
            return jornada;
          });
          // Armamos query
          var query = "";
          var nombre_funcion = "";
          // PREGUNTAMOS SI SE ESTA EDITANDO O CREANDO
          if (this.form.grupo) {
            nombre_funcion = "fn_actualiza_horario_rangos_general";
            query = `select control.fn_actualiza_horario_rangos_general('${
              this.form.descripcion
            }'::varchar,'${JSON.stringify(
              lista_horarios
            )}'::jsonb, '${JSON.stringify(lista_jornadas)}'::jsonb,${
              this.form.grupo
            },${user.id})`;
          } else {
            nombre_funcion = "fn_registra_horario_rangos_general";
            var query = `select control.fn_registra_horario_rangos_general('${
              this.form.descripcion
            }'::varchar,'${JSON.stringify(
              lista_horarios
            )}'::jsonb, '${JSON.stringify(lista_jornadas)}'::jsonb,${user.id})`;
          }
          // Ponemos secuencias de escape
          query = query.replace(/"/g, '\\"');
          // Ejecutamos la query
          let rpta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"${query}"){
                respuesta
                }
              }
            `
          });
          rpta = rpta.runQuery.respuesta[0][nombre_funcion];
          let resultado = rpta.split("|");

          if (rpta && resultado[0] == "1") {
            this.$message.success();
          } else {
            this.$message.error(resultado[1]);
          }
        } catch (error) {
          console.log(error);
        }
        this.loading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/horario/dialogs/CrearActualizarHorario.vue